import * as React from "react";
import { Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  label: string;
  currentValue?: number;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  required?: boolean;
}

export const DimensionInput: React.FC<Props> = ({
  label,
  currentValue,
  value,
  onChange,
  placeholder,
  required = false,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography sx={{ width: '80px' }}>{label}:</Typography>
      {currentValue !== undefined && (
        <Typography sx={{ width: '100px' }}>
          {currentValue.toFixed(2)} {t("components.dimensionInput.unit")}
        </Typography>
      )}
      <TextField
        size="small"
        placeholder={placeholder || (currentValue !== undefined ? `${t("components.dimensionInput.currentPrefix")}${currentValue.toFixed(2)}` : placeholder)}
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={value !== "" && (isNaN(parseFloat(value)) || parseFloat(value) <= 0)}
        helperText={value !== "" && (isNaN(parseFloat(value)) || parseFloat(value) <= 0) ? t("components.dimensionInput.errorMessage") : ""}
        sx={{ flex: 1 }}
        inputProps={{ min: 0, step: 0.01 }}
        required={required}
      />
    </Stack>
  );
};